import classnames from 'classnames'

import styles from './styles.module.scss'

interface GridCellsProps {
  cellSize: {
    height: number,
    width: number,
  },
  columns: number,
  dropPosition: {
    column: number,
    row: number,
    moduleColumns: number,
    moduleRows: number,
  },
  rows: number,
}

const GridCells = (props: GridCellsProps) => {
  const {
    cellSize: {
      height,
      width,
    },
    columns,
    dropPosition: {
      column: dropColumn,
      row: dropRow,
      moduleColumns,
      moduleRows,
    },
    rows,
  } = props

  const gridCells = []

  for (let row = 0; row < rows; row += 1){
    for (let col = 0; col < columns; col += 1){
      const topEdgeClass = (row === 0) ? styles.top : null
      const rightEdgeClass = (col + 1 === columns) ? styles.right : null
      const bottomEdgeClass = (row + 1 === rows) ? styles.bottom : null
      const leftEdgeClass = (col === 0) ? styles.left : null

      const activeClass = (
        (col >= dropColumn && col <= ((dropColumn + moduleColumns) - 1))
        && (row >= dropRow && row <= ((dropRow + moduleRows) - 1))
      ) ? styles.active : null

      gridCells.push(
        <div
          className={classnames(
            styles.root,
            topEdgeClass,
            rightEdgeClass,
            bottomEdgeClass,
            leftEdgeClass,
            activeClass,
          )}
          data-column={col}
          data-row={row}
          data-x={col * width}
          data-y={row * height}
          key={`grid_module_row_${row}_col_${col}`}
          style={{ width, height }}
        />,
      )
    }
  }

  return gridCells
}

export default GridCells
